import React from 'react';
import { Grid } from '@material-ui/core';
import { useWeb3React } from '@web3-react/core';

import ConnectWallet from '../../components/ConnectWallet';

import Header from './Header';
import Footer from './Footer';

import { CURRENT_CHAIN_ID } from '../../constants/global.constants';

import { useStyles } from './styles.module';

const Layout = ({ children }) => {
  const { chainId } = useWeb3React();
  const classes = useStyles();

  return (
    <Grid
      container
      className={classes.container}
    >
      <Grid item xs={12} className={classes.header}>
        <Header />
      </Grid>
      <Grid item xs={12} className={classes.content}>
        {CURRENT_CHAIN_ID.includes(chainId) ? (<>{children}</>) : (<ConnectWallet />)}
      </Grid>
      <Grid item xs={12} className={classes.footer}>
        <Footer />
      </Grid>
    </Grid>
  );
};

export default Layout;
